import { render, staticRenderFns } from "./StoryMaker.vue?vue&type=template&id=4dd4f643&scoped=true&"
import script from "./StoryMaker.vue?vue&type=script&lang=js&"
export * from "./StoryMaker.vue?vue&type=script&lang=js&"
import style0 from "./StoryMaker.vue?vue&type=style&index=0&id=4dd4f643&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd4f643",
  null
  
)

export default component.exports